"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _actionUtils = require("../../utils/actionUtils");
//Round Score to 2 decimal points
function roundScore(voiceIntensities) {
  Object.keys(voiceIntensities).forEach(function (element) {
    voiceIntensities[element] = parseFloat(parseFloat(voiceIntensities[element]).toFixed(2));
  });
  return voiceIntensities;
}

/**
 * @description Set attendees voice intensity
 * @param {object} voiceIntensities
 */
function setAttendeesVoiceIntensity(voiceIntensities) {
  return (0, _actionUtils.actionCreator)(_types.SET_ATTENDEE_VOICE_INTENSITY, roundScore(voiceIntensities));
}
var _default = exports["default"] = setAttendeesVoiceIntensity;